import { supabase } from '../supabaseClient'
import { filasSync, itemsConDatosIncidentes, type EstadoGuardado } from './sync-estados'
import { evaluateIncidentAutoCompliance } from './compliance-engine'
import { syncIncidentesAvisoMedidas, type TrazaItemIncidentes } from './incidentes/inc-checklist'

// PO-07 y PO-08 siguen la regla común de los syncs (sync-estados.ts). Desde el lote E, PO-09, PO-10, PO-12 y PO-13 los
// calcula incidentes/inc-checklist.ts (aviso al IESS con constancia y medidas correctivas cerradas con evidencia), que
// nunca pisa un estado manual. Sin la M46 en la base, esos cuatro siguen con la regla anterior.
const TODOS_LOS_ITEMS_INCIDENTES = ['PO-07', 'PO-08']
const ITEMS_ANTERIORES = ['PO-07', 'PO-08', 'PO-09', 'PO-10', 'PO-12', 'PO-13']

// Se llama al abrir el Checklist, al guardar un incidente o su investigación (CD 513), al registrar o borrar el aviso
// al IESS y al crear, cerrar, reabrir o borrar una medida correctiva. Devuelve lo que muestra el Checklist en PO-09/10/12/13.
export async function syncIncidentCompliance(companyId: string): Promise<Record<string, TrazaItemIncidentes>> {
  if (!companyId) return {}

  const trazas = await syncIncidentesAvisoMedidas(companyId).catch(err => { console.error('syncIncidentesAvisoMedidas', err); return null })
  const items = trazas ? TODOS_LOS_ITEMS_INCIDENTES : ITEMS_ANTERIORES

  const { data: incidents } = await supabase
    .from('incidents')
    .select('incident_type, iess_reported, corrective_actions, requires_investigation, investigator_id, investigation_date, immediate_cause, witnesses')
    .eq('company_id', companyId)

  const cumpleActual = evaluateIncidentAutoCompliance(incidents ?? [])

  const { data: existing } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .in('item_id', items)

  // Bloque 6, D: manda el módulo (sync-estados.ts): Cumple, En proceso si hay datos o Pendiente; nunca pisa un "No aplica".
  const rows = filasSync(companyId, items, cumpleActual, itemsConDatosIncidentes(incidents ?? []), (existing ?? []) as EstadoGuardado[], 'incidentes')

  if (rows.length > 0) await supabase.from('checklist_item_estados').upsert(rows, { onConflict: 'company_id,item_id' })
  return trazas ?? {}
}
